import React from 'react'
// import styles from './Marker.scss'
import * as L from 'react-leaflet'
import leaflet from 'leaflet'
import {MapTypeContext} from 'common/Map/MapTypeContext'
import {GoogleMarker} from 'common/Map/Marker/GoogleMarker'
import {MapboxMarker} from 'common/Map/Marker/MapboxMarker'
import {iconTypes} from './iconTypes'
import _ from 'lodash'

// the memoize here is important for performance reasons - if a
// leaflet.Icon instance is shared between leaflet.Marker instances,
// it enables some perf enhancements. Also, less GC.
const getLeafletIcon = _.memoize(iconSpec => leaflet.icon(iconSpec))

// Mapping-backend agnostic Marker component
export class Marker extends React.PureComponent {
  static defaultProps = {
    icon: 'default'
  }

  render () {
    const {position, icon, onClick, onMouseOver, onMouseOut} = this.props
    const iconSpec = (typeof icon === 'string')
      ? iconTypes[icon]
      : icon

    return <MapTypeContext.Consumer>
      {({mapType, mapInstance}) => {
        switch (mapType) {
          case 'leaflet':
            return <L.Marker
              position={position}
              icon={getLeafletIcon(iconSpec)}
              onClick={onClick}
              onMouseOver={onMouseOver}
              onMouseOut={onMouseOut} />
          case 'google':
            return <GoogleMarker
              mapInstance={mapInstance}
              position={position}
              icon={iconSpec}
              onClick={onClick}
              onMouseOver={onMouseOver}
              onMouseOut={onMouseOut} />
          case 'mapbox':
            return <MapboxMarker
              mapInstance={mapInstance}
              position={position}
              icon={iconSpec}
              onClick={onClick}
              onMouseOver={onMouseOver}
              onMouseOut={onMouseOut} />
          default:
            console.warn(`Marker rendered with unknown mapType '${mapType}'`)
            return null
        }
      }}
    </MapTypeContext.Consumer>
  }
}
